export var polarToCartesian = function (centerX, centerY, radius, angleInDegrees) {
    var angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;
    return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians),
    };
};
export var describeArc = function (x, y, radius, startAngle, endAngle) {
    var start = polarToCartesian(x, y, radius, endAngle);
    var end = polarToCartesian(x, y, radius, startAngle);
    var largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';
    return [
        "M ".concat(x, " ").concat(y),
        "L ".concat(start.x, " ").concat(start.y),
        "A ".concat(radius, " ").concat(radius, " 0 ").concat(largeArcFlag, " 0 ").concat(end.x, " ").concat(end.y),
        "L ".concat(x, " ").concat(y),
    ].join(' ');
};
